<template>
  <!-- 取消预约 -->

  <div>
    <el-row class="row-title">
      <el-button
        plain
        type="primary"
        @click="cancelOrder"
        style="margin-bottom: 10px"
        >取消预约</el-button
      >
    </el-row>

    <!-- 添加咨询的弹窗 -->
    <el-dialog
      title="取消预约"
      :visible.sync="adddialogVisible"
      width="400px"
      
      :close-on-click-modal="false"
      @close="closeAddDialog"
    >
      <el-form
        ref="addAdmission"
        :inline="true"
        :model="addCancelOrderForm"
        :rules="rules"
        class="demo-form-inline"
        label-width="90px"
      >
        <el-form-item label="床位信息" prop="bedno">
          <el-input
            v-model="addCancelOrderForm.bedno"
            placeholder
            @click.native="selectRoomdialogShow"
          ></el-input>
        </el-form-item>
        <el-form-item label="老人姓名" prop="oldname">
          <el-input
            v-model="addCancelOrderForm.oldName"
            disabled
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item label="原因" prop="reason">
          <el-input
            v-model="addCancelOrderForm.reason"
            placeholder
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="128"
            show-word-limit
            resize="none"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="addCancelOrderForm.remark"
            placeholder
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="128"
            show-word-limit
            resize="none"
            style="width: 200px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="adddialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAdminssion('addAdmission')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 添加修改弹窗 -->
    <el-dialog
      :title="fixOrQuery ? '修改取消预约' : '查看详情'"
      :visible.sync="fixAdmissiondialog"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form
        :inline="true"
        :model="fixAdmisson"
        class="demo-form-inline"
        label-width="90px"
        ref="fixAdmission"
        :rules="rules"
      >
        <el-form-item label="老人姓名" prop="oldname">
          <el-input v-model="fixOldName" disabled readonly></el-input>
        </el-form-item>
        <el-form-item label="原因" prop="reason">
          <el-input
            v-model.trim="fixAdmisson.reason"
            :disabled="disabled"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="128"
            show-word-limit
            resize="none"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="fixAdmisson.remark"
            :disabled="disabled"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="128"
            show-word-limit
            resize="none"
            style="width: 200px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="fixOrQuery" @click="fixAdmissiondialog = false"
          >取消</el-button
        >
        <el-button type="primary" @click="fixList">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 房间床位选择弹窗 -->
    <el-dialog
      title
      style="margin-top: -10vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="roomBeddialogVisible"
      width="80%"
    >
      <el-row>
        <span style="margin-left: 20px">正式入住:{{ checkIn }}人</span>
        <span style="margin-left: 20px">空床:{{ nullBed }}张</span>
        <span style="margin-left: 20px">已预约:{{ order }}张</span>
        <span style="margin-left: 20px">试入住:{{ tryIn }}人</span>
        <span style="margin-left: 30px">楼栋:</span>
        <el-select
          v-model="buildName"
          placeholder="请选择"
          style="width: 120px"
          @change="selectRoomdialogShow"
        >
          <el-option
            v-for="item in BuildList"
            :key="item.value"
            :label="item.buildingName"
            :value="item.buildingName"
          ></el-option>
        </el-select>
        <img
          src="@/assets/beadhouse/nan.png"
          style="
            display: inline-block;
            vertical-align: middle;
            margin-left: 30px;
          "
        />
        <span>男</span>
        <img
          src="@/assets/beadhouse/nv.png"
          style="
            display: inline-block;
            vertical-align: middle;
            margin-left: 20px;
          "
        />
        <span>女</span>
        <img
          src="@/assets/beadhouse/kongchuang_icon.png"
          style="
            display: inline-block;
            vertical-align: middle;
            margin-left: 20px;
          "
        />
        <span>空床</span>
        <img
          src="@/assets/beadhouse/yiyuyue.png"
          style="
            display: inline-block;
            vertical-align: middle;
            margin-left: 20px;
          "
        />
        <span>已预约</span>
      </el-row>
      <el-row>
        <room-bed-show
          v-bind:yuyue="2"
          v-bind:floorlist="floorList"
          v-bind:type="2"
          @getChildRoomBedData="clickRoomBedData"
        ></room-bed-show>
      </el-row>
    </el-dialog>

    <el-table
      style="width: 100%; margin-top: 10px"
      :data="cancelOrderList"
      :header-cell-style="{
        'text-align': 'center',
        'font-size': '16px',
        'font-weight': '600',
        color: '#2d2d2d',
        'background-color': '#d4f5fa',
      }"
      :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
      :row-style="tableRowStyle"
    >
      <el-table-column prop="old_Name" label="老人姓名"></el-table-column>
      <el-table-column prop="cancel_Reason" label="原因"></el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column label="操作" width="280">
        <template slot-scope="scope">
          <el-button
              style="margin-right: 5px"
              type="primary"
              size="mini"
              plain
              @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              style="margin-right: 5px"
              type="danger"
              size="mini"
              plain
              @click="handleRemove(scope.$index, scope.row)"
              >删除</el-button
            >
            <el-button
              style="margin-right: 5px"
              type="success"
              size="mini"
              plain
              @click="handleAdmission(scope.$index, scope.row)"
              >查看</el-button
            >
          <!-- <a @click="handleEdit(scope.$index, scope.row)" class="curcor">
            <img src="@/assets/beadhouse/xiugai_icon_1.png" />
          </a>
          <a @click="handleRemove(scope.$index, scope.row)" class="curcor">
            <img src="@/assets/beadhouse/shanchu_icon.png" />
          </a>
          <a @click="handleAdmission(scope.$index, scope.row)" class="curcor">
            <img src="@/assets/beadhouse/chakan_icon.png" />
          </a> -->
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="center-pg fenye"
      ref="pagination"
      background
      @current-change="handleCurrentChange"
      :page-size="10"
      layout="total, prev, pager, next"
      :total="total"
      align="center"
    ></el-pagination>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import RoomBedShow from "@/components/RoomBedShow"; //引入第三方组件

export default {
  name: "AdmissionCancel",
  components: {
    RoomBedShow,
  },
  data() {
    return {
      //取消预约列表数据
      cancelOrderList: [
        {
          old_Name: "",
          cancel_Reason: "",
          remark: "",
        },
      ],
      total: 0, //分页总数
      pageNum: 1, //当前页
      pageSize: 10, //显示条数
      adddialogVisible: false, //取消预约弹窗显示
      rules: {
        bedno: [
          { required: true, message: "请输入床位信息", trigger: "focus" },
        ],
        reason: [
          {
            required: true,
            pattern: /[^\s]/,
            message: "请输入取消原因",
            trigger: "blur",
          },
        ],
      },
      //添加咨询弹窗表单数据
      addCancelOrderForm: {
        bedno: "",
        oldName: "",
        reason: "",
        remark: "",
        bedid: "",
      },
      roomBeddialogVisible: false, //dialog显示与否
      floorList: [], //子组件使用的
      currentFloorList: [],
      buildId: 0, //当前的楼栋选择id
      BuildList: [],
      buildName: "",
      adminssionId: "", //咨询列表的id
      fixAdmissiondialog: false, //修改弹窗
      fixOldName: "", //修改页面的老人姓名

      //修改弹窗信息
      fixAdmisson: {
        reason: "",
        remark: "",
      },
      fixOrQuery: true, //修改查看弹窗状态切换
      disabled: true,
      rowId: "", //修改当前数据的id
      //床位信息
      checkIn: "0",
      nullBed: "0",
      order: "0",
      tryIn: "0",
    };
  },
  methods: {
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    //查询取消预约
    getAdmissionCancel() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.$postJson("omc/advisoryCancel/queryListWithPage", param).then(
        (res) => {
          this.cancelOrderList = res.result.list;
          this.total = Number(res.result.total);
        }
      );
    },

    //删除按钮
    handleRemove(index, row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        center:true
      })
        .then(() => {
          this.$postJson("omc/advisoryCancel/deleteById/" + row.id).then(
            (res) => {
              if (res.code == 200) {
                this.$message({ message: "删除成功", type: "success" });
                this.getAdmissionCancel(); //重新渲染页面
              } else {
                this.$message({
                  message: "添加失败, " + res.message,
                  type: "error",
                });
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //修改列表
    fixList() {
      this.fixAdmissiondialog = false;
      if (this.fixOrQuery) {
        let param = {
          id: this.rowId,
          remark: this.fixAdmisson.remark,
          cancelReason: this.fixAdmisson.reason,
        };
        this.$postJson("omc/advisoryCancel/edit", param).then((res) => {
          if (res.code == 200) {
            this.$message({ message: "修改成功", type: "success" });
            this.getAdmissionCancel(); //重新渲染页面
          } else {
            this.$message({
              message: "添加失败, " + res.message,
              type: "error",
            });
          }
        });
      }
    },

    //添加提交表单
    addAdminssion(addAdmission) {
      this.$refs[addAdmission].validate((valid) => {
        //表单验证
        if (valid) {
          this.adddialogVisible = false;
          let param = {
            oldName: this.addCancelOrderForm.oldName,
            bedId: this.addCancelOrderForm.bedid,
            cancelReason: this.addCancelOrderForm.reason,
            remark: this.addCancelOrderForm.remark,
            advisoryId: this.adminssionId,
          };
          this.$postJson("omc/advisoryCancel/add", param).then((res) => {
            if (res.code == 200) {
              this.$message({ message: "添加成功", type: "success" });
              this.getAdmissionCancel(); //重新渲染页面
            } else {
              this.$message({
                message: "添加失败, " + res.message,
                type: "error",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //获取入住信息
    getIntoDetail() {
      this.$postJson("omc/Bed/queryBedStatus/" + this.buildId).then((res) => {
        //初始化床位数量
        (this.checkIn = "0"),
          (this.nullBed = "0"),
          (this.order = "0"),
          (this.tryIn = "0"),
          console.log(res);
        for (var i = 0; i < res.result.length; i++) {
          if (res.result[i].status == 0) {
            this.nullBed = res.result[i].count;
          } else if (res.result[i].status == 5) {
            this.tryIn = res.result[i].count;
          } else if (res.result[i].status == 2) {
            this.checkIn = res.result[i].count;
          } else if (
            res.result[i].status == 3 ||
            res.result[i].status == 4 ||
            res.result[i].status == 6
          ) {
            this.order = Number(this.order) + Number(res.result[i].count);
          }
        }
      });
    },

    //获取楼层信息
    getfloor() {
      this.$postForm("omc/Building/showAlls").then((res) => {
        console.log(res);
        this.BuildList = res.result;
        this.buildName = res.result[0].buildingName; //初始化房间楼栋
      });
    },

    //取消预约的添加按钮
    cancelOrder() {
      this.adddialogVisible = true;
    },

    //清空表单
    closeAddDialog() {
      this.$refs["addAdmission"].resetFields();
      this.addCancelOrderForm.remark = "";
      this.addCancelOrderForm.oldName = "";
    },

    //修改按钮
    handleEdit(index, row) {
      this.fixOrQuery = true;
      this.fixOldName = row.old_Name;
      this.fixAdmisson.reason = row.cancel_Reason;
      this.fixAdmisson.remark = row.remark;
      this.fixAdmissiondialog = true;
      //状态变为点击
      this.disabled = false;
      this.rowId = row.id;
    },

    //查看详情按钮
    handleAdmission(index, row) {
      this.fixOrQuery = false;
      this.fixOldName = row.old_Name;
      this.fixAdmissiondialog = true;
      this.fixAdmisson.reason = row.cancel_Reason;
      this.fixAdmisson.remark = row.remark;
      //状态变为不许点击
      this.disabled = true;
    },

    //翻页
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getAdmissionCancel();
    },
    selectRoomdialogShow() {
      let aa = this.BuildList;
      let build = this.BuildList.filter((item) => {
        return item.buildingName == this.buildName;
      });
      this.floorList = build[0].floorList;
      this.buildId = build[0].buildingId;
      this.getBuildFloorList();
      this.getIntoDetail();
    },

    //查询预约老人的信息
    getOldAdmission(bedId) {
      this.$postJson("omc/advisoryCancel/getOldNameByBedId/" + bedId).then(
        (res) => {
          this.addCancelOrderForm.oldName = res.result.oldName;
          this.adminssionId = res.result.id;
        }
      );
    },

    getBuildFloorList() {
      this.$postForm("omc/Room/showAll", { buildingId: this.buildId }).then(
        (res) => {
          if (res.result) {
            this.currentFloorList = res.result.floorList;
            this.controlFloorData();
          }
        }
      );
    },

    //处理楼层全部数据
    controlFloorData() {
      //为了一个房间太多床位的显示异常
      let floorList = [];
      for (let i = 0; i < this.currentFloorList.length; i++) {
        let roomList = [];
        //获取房间列表
        for (let j = 0; j < this.currentFloorList[i].roomList.length; j++) {
          let pageList = [];
          this.currentFloorList[i].roomList[j] = this.getBedSrc(
            this.currentFloorList[i].roomList[j]
          );
          let allBedList = this.currentFloorList[i].roomList[j].bedList;
          //切割数组,然后进行分页添加上去
          for (var k = 0; k < allBedList.length; k += 4) {
            var bedList = allBedList.slice(k, k + 4);
            pageList.push({
              bedList: bedList,
            });
          }
          let roomData = {
            roomno: this.currentFloorList[i].roomList[j].roomNo,
            roomId: this.currentFloorList[i].roomList[j].roomId,
            roomType: this.currentFloorList[i].roomList[j].roomType,
            pageList: pageList,
          };
          roomList.push(roomData);
        }

        let floorData = {
          floorNo: this.currentFloorList[i].floorNo,
          roomList: roomList,
        };
        floorList.push(floorData);
      }
      this.floorList = floorList;
      this.roomBeddialogVisible = true;
    },

    //根据房间和床位,设置它的src,如果需要修改显示的逻辑,请修改这里
    getBedSrc(roomData) {
      var bedList = roomData.bedList;
      roomData.bedList.forEach((bedItem) => {
        //试入住
        if (bedItem.status == 5) {
          if (bedItem.sex == 0) {
            bedItem.src = require("@/assets/beadhouse/shiruzhu_nan.png");
          } else {
            bedItem.src = require("@/assets/beadhouse/shiruzhu_nv.png");
          }
        }

        //入住
        if (bedItem.status == 2) {
          if (bedItem.sex == 0) {
            bedItem.src = require("@/assets/beadhouse/nan.png");
          } else {
            bedItem.src = require("@/assets/beadhouse/nv.png");
          }
        }

        //预约
        if (bedItem.status == 3) {
          bedItem.src = require("@/assets/beadhouse/yiyuyue.png");
        }

        //空床
        if (bedItem.status == 0) {
          bedItem.src = require("@/assets/beadhouse/kongchuang_icon.png");
        }

        //待缴费
        if (bedItem.status == 7) {
          if (bedItem.sex == 0) {
            bedItem.src = require("@/assets/beadhouse/daijiaofei_nan.png");
          } else {
            bedItem.src = require("@/assets/beadhouse/daijiaofei_nv.png");
          }
        }

        //调房调级中
        if (bedItem.status == 6) {
          bedItem.src = require("@/assets/beadhouse/tiaozhengzhong_nan.png");
        }
      });
      return roomData;
    },

    //选择床位后的回调
    clickRoomBedData(data) {
      if (data.type == 2) {
        if (data.bedtype.status !== 3) {
          this.$alert("此床位未被预约，请重新选择", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
        } else {
          this.roomBeddialogVisible = false;
          this.addCancelOrderForm.bedno = data.bedno;
          this.addCancelOrderForm.bedid = data.bedid;
          this.getOldAdmission(data.bedid);
        }
      }
    },
  },
  mounted() {
    this.getAdmissionCancel();
    this.getfloor();
    this.getIntoDetail();
  },
};
</script>
<style lang="scss" scoped>

.toolbar{
  padding-left: 8px;
  padding-top: 5px;
}
::v-deep .el-dialog__header {
  height: 19px !important;
  text-align: left;
}
::v-deep .el-dialog__footer {
  text-align: center;
}
.fenye {
  padding: 30px 0;background: #fff;
}

</style>
